import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { RefreshIndicator } from 'material-ui';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import environment from '../../relay/environment';
import VendorDetail from './VendorDetail';

@connect(state => ({
  windowHeight: state.Responsive.get('windowHeight'),
}))
class Renderer extends React.Component {
  static propTypes = {
    windowHeight: PropTypes.number.isRequired,
    activeVendor: PropTypes.string.isRequired,
  }

  render() {
    const { windowHeight, activeVendor } = this.props;
    const top = ((windowHeight - 161) / 2) + 161;

    const loadingEl = (<RefreshIndicator
      top={top}
      left={900}
      status='loading'
    />);

    return (<QueryRenderer
      environment={environment}
      variables={{
        vendorId: activeVendor,
      }}
      query={graphql`
        query VendorDetailsRenderer_VendorDetails_Query($vendorId: ID!) {
          vendor(id: $vendorId) {
            id,
            name,
            sabreCode,
            contacts,
            amenityPrograms,
            profileNotes,
            travelers {
              id,
              fullName
            }
          }
        }
      `}
      render={({ error, props }) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          const { vendor } = props;

          return <VendorDetail vendor={vendor} />;
        }

        return loadingEl;
      }}
    />);
  }
}

export default Renderer;



// WEBPACK FOOTER //
// /src/components/Vendors/VendorDetailsRenderer.js